import styled from 'styled-components';
var ItemDetailsContainer = styled.div.withConfig({
  displayName: "ItemDetailsContainer",
  componentId: "sc-1i3fmow-0"
})(["align-self:stretch;display:flex;flex-direction:column;justify-content:space-between;"]);
export default ItemDetailsContainer;